import React from "react";
import { useNavigate } from "react-router-dom";

const NoModuleAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12 text-center">
      {/* Icon / Illustration */}
      <div className="mb-4">
        <svg
          className="h-24 w-24 mx-auto text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>

      {/* Main Message */}
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        Access Denied
      </h1>

      <p className="text-xl text-gray-600 mb-8 max-w-md">
        Permissions revoked – you do not have access to any modules at this time.
      </p>

      <p className="text-gray-500 mb-8 max-w-md">
        Please contact your administrator to restore access or assign the appropriate module permissions.
      </p>
    </div>
  );
};

export default NoModuleAccess;